import { useEffect, useState } from 'react';
import { MessageS } from '../MessageS';
import { useJwtClaims } from '../Context/AuthContext';

// eslint-disable-next-line import/prefer-default-export
export const useUnreadMessagesCount = (contactIds?: number[]) => {
  const [trigger, setTrigger] = useState<number>();
  const [unreadCount, setCount] = useState<number | null | undefined>();

  useEffect(() => {
    if (contactIds && contactIds.length > 0) {
      MessageS.getUnreadCount(contactIds).then(setCount);
    }
  }, [contactIds, trigger]);

  const refresh = () => setTrigger(Date.now());

  const increment = () =>
    setCount((prev) => {
      if (prev) return prev + 1;
      return undefined;
    });

  const decrement = () =>
    setCount((prev) => {
      if (prev) return prev - 1;
      return undefined;
    });

  return { unreadCount, refresh, increment, decrement };
};

export const useGeneralUnreadMessagesCount = () => {
  const [trigger, setTrigger] = useState<number>();
  const { profileId } = useJwtClaims();
  const [unreadCount, setCount] = useState<number | null | undefined>();

  useEffect(() => {
    if (profileId) MessageS.getUnreadCount([]).then(setCount);
  }, [trigger, profileId]);

  const refresh = () => setTrigger(Date.now());

  const increment = () =>
    setCount((prev) => {
      if (prev) return prev + 1;
      return undefined;
    });

  const decrement = () =>
    setCount((prev) => {
      if (prev) return prev - 1;
      return undefined;
    });

  return { unreadCount, refresh, increment, decrement };
};
